import React from "react";
import Sponsor from "./Sponsor";

export default function JuanaManso({ userEmail }) {
  return (
    <div className="container contOption">
      {/* Reutiliza toda la lógica ya probada */}
      <Sponsor userEmail={userEmail} />
    </div>
  );
}
